import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const defaultBaseUrl = (() => {
  if (typeof window === 'undefined') {
    return 'http://127.0.0.1:8000'
  }
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://127.0.0.1:8000'
  }
  return 'https://changxin10m.com'
})()

const store = new Vuex.Store({
  state: {
    blogpostsum: 0,
    baseUrl: defaultBaseUrl,
    motto: '',
    allBlogs:null,
    tagContent:{},
    blogPost:{},
    archive:null,
    share:null
  },
  mutations: {
    assignment (state, postblogsum) {
      state.blogpostsum = postblogsum
    },
    assignBaseUrl (state, url) {
      state.baseUrl = url
    },
    assignAllBlogs(state, allBlogs){
      state.allBlogs=allBlogs
    },
    assignTagContent(state, content){
      state.tagContent= content
    },
    assignArchive(state, archive){
      state.archive= archive
    },
    assignShare(state, share){
      state.share= share
    },
    assignBlogPost(state, blogPost){
      state.blogPost = blogPost;
       window.localStorage.setItem('blogPost',JSON.stringify(blogPost));
    }
  }
});

export default store
